<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">
      <p>{{itemSetting.action.label[lang]}}</p>
      <span v-if="passed !== null && passed === false" class="validateMessage notranslate">({{locale.required}})</span>
      <div v-if="optionCondition.message" class="notranslate"><span class="conditionMessage" :class="{passed: condition}">{{optionCondition.message}}</span></div>
    </div>
    <div
      v-for="(option, index) in itemSetting.action.item"
      :key="index"
      :class="{
        quantityOption: hasQuantity,
        isChecked: value.includes(`${index}_${option.value}`)
      }"
      class="listItem checkbox">
      <input type="checkbox"
        :name="`checkbox_${id}`"
        :id="`checkbox_${id}_${index}`"
        :value="option.id || `${index}_${option.value}`"
        :disabled="disabled(`${index}_${option.value}`) ||
        (optionTotalQuantity && optionTotalQuantity.isDisabled && !value.includes(`${index}_${option.value}`))
        "
        v-model="value"
        @change="priceOption(option, index, $event)">
      <label :for="`checkbox_${id}_${index}`" :style="valueStyle">
        <span v-html="option.label[lang]"></span>
        <span class="optionPrice priceDpBoard notranslate">{{priceFormat(option.price)}}</span>
      </label>
      <!-- 옵션별 수량 설정 -->
      <div
        v-if="hasQuantity"
        class="quantity">
        <button
          type="button"
          class="btnQuantity"
          data-quantity="minus"
          :disabled="Number(option.quantity) === itemSetting.action.min || !value.includes(`${index}_${option.value}`)"
          @click="dec(option, index)">-</button>
        <input type="text"
          class="inputQuantity"
          :placeholder="`${itemSetting.action.min} ~ ${itemSetting.action.max}`"
          :value="option.quantity"
          disabled>
        <button
          type="button"
          class="btnQuantity"
          data-quantity="plus"
          :disabled="(optionTotalQuantity && optionTotalQuantity.isDisabled) || (Number(option.quantity) === itemSetting.action.max || !value.includes(`${index}_${option.value}`))"
          @click="inc(option, index)">+</button>
      </div>
      <!-- //옵션별 수량 설정 -->
      <!-- 옵션별 선택에 따른 추가옵션(서브) -->
      <div v-if="value.length > 0 && value.filter(x => x.split('_').splice(1).join('') === option.value).length > 0 && getSubOption(option) && getSubOption(option).length > 0" class="break">
        <!-- <button
          type="button"
          class="btn btnWhite sizeXs mt5"
          @click="setSubOption(option)">
          {{option.label[lang]}} > {{locale.page_suboption}}
        </button> -->
        <div v-for="sub in getSubOption(option)"
          :key="sub.id"
          class="subOption">
          <component
            :is="sub.name.replace(/\b\w/g, l => l.toUpperCase())"
            :locale="locale"
            :lang="lang"
            :id="sub.id"
            :itemSetting="sub.setting"
            :subOption="subOption"
            :isSub="true" />
        </div>
      </div>
      <!-- //옵션별 선택에 따른 추가옵션(서브) -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import regExp from '@/common/regExp'
import Input from './Input.vue'

export default {
  name: 'Checkbox',
  props: [
    'id',
    'itemSetting',
    'lang',
    'locale',
    'isSub',
    'subOption',
    'storageData'
  ],
  components: {
    Input,
    Radio : () => import ('./Radio.vue'),
    Select: () => import ('./Select.vue')
  },
  computed: {
    ...mapGetters({
      price: 'page/getPrice',
      submitData: 'submit/getSubmitData'
    }),
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    currency () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    hasPrice () {
      return this.$store.state.page.hasPrice
    },
    hasQuantity () {
      return this.itemSetting.action.optionQuantity
    },
    value: {
      get () {
        const data = typeof (this.submitData.find(x => x.id === this.id)) === 'undefined' ? '' : this.submitData.find(x => x.id === this.id).value
        return data
      },
      set (value) {
        this.setSubmitData(value)
      }
    },
    optionCondition () {
      const gtVal = this.itemSetting.action.conditionGtVal
      const ltVal = this.itemSetting.action.conditionLtVal
      const specificVal = this.itemSetting.action.conditionSpecificVal
      const hasGt = this.itemSetting.action.conditionGt && gtVal
      const hasLt = this.itemSetting.action.conditionLt && ltVal
      const hasSpecific = this.itemSetting.action.conditionSpecific && specificVal
      let message = ''
      if (hasGt && !hasLt) {
        message = `${gtVal}${this.locale.option_condition_gt}`
      } else if (hasLt && !hasGt) {
        message = `${ltVal}${this.locale.option_condition_lt}`
      } else if (hasGt && hasLt) {
        message = `${gtVal} ~ ${ltVal}${this.locale.option_condition_range}`
      } else if (hasSpecific) {
        message = `${specificVal}${this.locale.option_condition_specific}`
      } else {
        message = null
      }
      return {
        ...hasGt && {
          gt: gtVal
        },
        ...hasLt && {
          lt: ltVal
        },
        ...hasSpecific && {
          specific: specificVal
        },
        message: message
      }
    },
    optionTotalQuantity () {
      const optionCondition = this.optionCondition
      const isCondition = optionCondition.message && this.itemSetting.action.optionQuantity
      const valueIndex = this.value && this.value.map(x => parseInt(x.split('_')[0]))
      const items = valueIndex && this.itemSetting.action.item.filter((x, i) => valueIndex.includes(i))
      const totalQuantity = items && items.map(x => x.quantity).reduce((a, b) => a + b, 0)
      const max = optionCondition && (optionCondition.specific || optionCondition.lt)
      return isCondition && {
        totalQuantity: totalQuantity,
        isDisabled: totalQuantity >= max
      }
    },
    disabled () {
      return (option) => {
        /**
         * 최대선택개수(lt)
         * 또는 지정개수(specific)가 존재하고
         * 체크가 조건에 충족되면 disblaed 처리
         */
        const condition = this.optionCondition
        const max = condition.lt || condition.specific
        const value = this.value
        return (max === value.length) && !value.includes(option)
      }
    },
    passed () {
      return this.submitData && this.submitData.find(x => x.id === this.id)
        ? this.submitData.find(x => x.id === this.id).passed
        : null
    },
    moduleAll () {
      return this.$store.getters['page/getPage']
    },
    subOptions () {
      const moduleAll = this.moduleAll.module
      const sub = this.submitData && this.submitData.find(x => x.id === this.id) ? this.submitData.find(x => x.id === this.id).subOption : []
      return sub && moduleAll
        ? moduleAll.filter(x => sub.map(s => s.subOption).includes(x.id))
        : null
    }
  },
  watch: {
    value: {
      deep: true,
      handler (value) {
        if (value) {
          this.setSubmitData(value)
        }
      }
    },
    hasPrice (hasPrice) {
      if (hasPrice) {
        if (this.itemSetting.action.hasDefault && this.itemSetting.action.defaultValue !== '') {
          const dValue = this.itemSetting.action.defaultValue.map(x => x.split('_').splice(1).join(''))
          const item = this.itemSetting.action.item
          const setPriceOption = this.priceOption
          item.forEach(function (option, index) {
            if (dValue.includes(option.value)) {
              setPriceOption(option, index)
            }
          })
        }
      }
    },
    optionTotalQuantity: {
      deep: true,
      handler (data) {
        if (data && this.value) {
          this.setSubmitData(this.value)
        }
      }
    }
  },
  data () {
    return {
      calculate: 0,
      condition: null
    }
  },
  methods: {
    setSubmitData (value) {
      const passed = !this.itemSetting.action.isRequired ? null : value.length > 0
      const isQuantity = this.itemSetting.action.optionQuantity
      const optionCondition = this.optionCondition
      const optionTotalQuantity = this.optionTotalQuantity && this.optionTotalQuantity.totalQuantity
      const getCondition = function () {
        let result = true
        if (optionCondition.message !== null) {
          const gt = optionCondition.gt
          const lt = optionCondition.lt
          const spec = optionCondition.specific
          const val = isQuantity && !isNaN(optionTotalQuantity) ? optionTotalQuantity : value.length
          if (gt && val < gt) {
            result = false
          } else if (lt && (val <= 0 || val > lt)) {
            result = false
          } else if (spec && val !== spec) {
            result = false
          }
        }
        return result
      }
      const options = this.itemSetting.action.item
      const data = {
        id: this.id,
        value: value,
        valueOption: options,
        passed: passed,
        condition: getCondition()
      }
      this.condition = getCondition()
      this.$store.commit('submit/setValue', data)
    },
    priceFormat (price) {
      const code = this.currency
      return price ? regExp.priceFormat(price, code) : ''
    },
    priceOption (option, i, event) {
      const isChecked = event.target.checked
      const lang = this.lang
      const hasQuantity = this.hasQuantity
      const p = regExp.uncomma(option.price)
      const price = typeof (p) === 'undefined' || p === '' ? 0 : Number(p.replace(/\(|\)|\+/g, ''))
      const value = this.value && this.value.map(x => x.split('_').splice(1).join(''))
      const data = {
        optId: this.id,
        id: `${this.id}_${i}`,
        itemLabel: this.itemSetting.action.labelValue,
        label: option.label[lang],
        price: price,
        quantity: hasQuantity ? option.quantity : null,
        toggle: isChecked ? 'add' : 'remove',
        ...this.subOptions && {
          subOptionList: this.subOptions.map(x => x.id),
          ...(this.subOption.filter(x => x.parent === this.id).length > 0 && this.subOption.filter(x => x.parent === this.id).filter(x => value.includes(x.parentValue)).length > 0) && {
            subOptionValue: this.subOption.filter(x => x.parent === this.id).filter(x => value.includes(x.parentValue)).map(x => x.child)
          }
        },
        ...this.isSub && {
          isSub: this.isSub,
          parentOption: this.itemSetting.action.parentOption
        }
      }
      this.$store.commit('page/priceOption', data)
    },
    inc (option, i) {
      this.itemSetting.action.item[i].quantity++
      // this.priceOption(option, i)
      const data = {
        id: `${this.id}_${i}`,
        index: i,
        quantity: option.quantity
      }
      this.$store.commit('page/updateOption', data)
    },
    dec (option, i) {
      this.itemSetting.action.item[i].quantity--
      // this.priceOption(option, i)
      const data = {
        id: `${this.id}_${i}`,
        index: i,
        quantity: option.quantity
      }
      this.$store.commit('page/updateOption', data)
    },
    getSubOption (option) {
      const mods = this.subOptions ? this.subOptions.filter(x => x.id === option.subOption) : null
      return mods
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox input[disabled] + label {
  color: $color-grey;
  &:before {
    background-color: $color-lgrey2;
  }
}
</style>
